import { render, staticRenderFns } from "./ObiOnBoardingHeader.vue?vue&type=template&id=0b34be4c&scoped=true&"
import script from "./ObiOnBoardingHeader.vue?vue&type=script&lang=js&"
export * from "./ObiOnBoardingHeader.vue?vue&type=script&lang=js&"
import style0 from "./ObiOnBoardingHeader.vue?vue&type=style&index=0&id=0b34be4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34be4c",
  null
  
)

export default component.exports